"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/*
 * Jira Ticket:
 * Created Date: Mon, 13th Jan 2020, 12:19:42 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */
var formStyles = function formStyles() {
  return {
    form: {
      padding: '5%',
      paddingTop: 0,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    },
    input: {
      marginTop: '1em',
      width: '85%'
    },
    textinput: {
      width: '85%'
    },
    button: {
      display: 'flex',
      marginLeft: '7.5%',
      width: '85%',
      backgroundColor: '#2196f3',
      color: 'white',
      marginBottom: '5%',
      paddingTop: 15,
      paddingBottom: 15,
      '&:hover': {
        backgroundColor: '#0069c0'
      }
    }
  };
};

var _default = formStyles;
exports.default = _default;